import { render, staticRenderFns } from "./PayslipDetailsModal.vue?vue&type=template&id=4f225bf9"
import script from "./PayslipDetailsModal.vue?vue&type=script&lang=js"
export * from "./PayslipDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports